import React from "react"

interface CustomizeButtonProps {
  count: number,
  onClick: () => void,
}

class CustomizeButtonInner extends React.Component<CustomizeButtonProps> {
  render() {
    const { onClick, count } = this.props
    return (
      <button
        onClick={() => onClick()}
        className="absolute bottom-0 right-0 pr-4 pl-3 py-2 bg-white hover:bg-gray-100
                   rounded-tl-xl border-t border-l border-gray-300"
      >
        <span className="inline-block">
          <span className="rounded-full bg-yellow-400 flex justify-center items-center w-6 h-6">
            <span className="text-yellow-900 text-sm">
              {count}
              <span className="sr-only">customization options available.</span>
            </span>
          </span>
        </span>
        &nbsp;
        Personalize this Meal
      </button>
    )
  }
}

export function CustomizeButton(props: CustomizeButtonProps) {
  return <CustomizeButtonInner {...props} />
}
